var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"landing__logo",attrs:{"href":"/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }